import { render, staticRenderFns } from "./Form12Table.vue?vue&type=template&id=7075f978"
import script from "./Form12Table.vue?vue&type=script&lang=ts"
export * from "./Form12Table.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports